/**
 * Valida os botões personalizados do bot
 * @param {Array} buttons - Array de botões com propriedades text e url
 * @returns {Object} - { isValid: boolean, error: string|null, validButtons: Array }
 */
export const validateButtons = (buttons) => {
    const validButtons = [];
    const allowedColors = new Set(["default", "green", "red", "blue"]);

    for (const btn of buttons) {
        // Ignora botões completamente vazios
        if (!btn.text && !btn.url) continue;

        // Verifica se ambos os campos estão preenchidos
        if (!btn.text || !btn.url) {
            return {
                isValid: false,
                error: "Todos os botões devem ter texto E link preenchidos, ou deixe ambos vazios.",
                validButtons: []
            };
        }

        // Validar se o texto está vazio (apenas espaços)
        if (btn.text.trim().length === 0) {
            return {
                isValid: false,
                error: "O texto do botão não pode estar vazio.",
                validButtons: []
            };
        }

        // Valida tamanho do texto
        if (btn.text.length > 64) {
            return {
                isValid: false,
                error: `Texto do botão muito longo: "${btn.text.substring(0, 20)}..." (máx. 64 caracteres)`,
                validButtons: []
            };
        }

        // Valida tamanho da URL
        if (btn.url.length > 200) {
            return {
                isValid: false,
                error: `URL muito longa: "${btn.url.substring(0, 30)}..." (máx. 200 caracteres)`,
                validButtons: []
            };
        }

        // Valida formato da URL - deve começar com https://, http:// ou t.me/
        if (!btn.url.match(/^(https?:\/\/|t\.me\/)/i)) {
            return {
                isValid: false,
                error: `URL inválida: "${btn.url}". Use URLs começando com https:// ou t.me/`,
                validButtons: []
            };
        }

        const color = (btn.color || "default").toString().trim().toLowerCase();
        validButtons.push({
            ...btn,
            color: allowedColors.has(color) ? color : "default"
        });
    }

    return {
        isValid: true,
        error: null,
        validButtons
    };
};
